module.exports = "<div class=\"wrapper wrapper-full-page\" [ngClass]=\"{'login-background': isLoginBackground }\">\n\n  <app-sidebar></app-sidebar>\n\n  <div class=\"main-panel\">\n    <app-navbar></app-navbar>\n    <app-dashboard></app-dashboard> \n    <!--<div *ngIf=\"isMaps('/maps')\">-->\n    <!--<footer-cmp></footer-cmp>-->\n    <!--</div>-->\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main